// Imports
import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import LoadingRow from '../../../../../../shareables/foundation/front-end/components/tables/loading-row';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetDocumentsResponse } from '../../../../../../shareables/types/api/main/website/page/type/201/documents/get';
import DocumentsRow from './row';
import Table from '../shared-components/table';
import EmptyStateRow from '../shared-components/table/empty-state-row';


// Styled components
const Container = styled.div`
	padding-bottom: 0.625rem;
	
	@media only screen and (max-width: 47.9375rem) {
		padding-bottom: 0;
	}
`;

const UploadedCell = styled.th`
	min-width: 7.8125rem;
`;


// Define the accepted props
interface Props {
	pageID: number;
	storybookDocuments?: GetDocumentsResponse;
}


// Function component
const Documents: React.FC<Props> = ({ pageID, storybookDocuments }) => {
	// Use state
	const [documents, setDocuments] = useState<GetDocumentsResponse | null>(storybookDocuments ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load documents on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetDocumentsResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/page/id_${pageID}/type/201/documents`,
				completion: (json) => {
					setDocuments(json.response);
				},
			})
		);
	}, [dispatch, pageID]);
	
	
	// Return JSX
	return (
		<Container>
			<Table>
				<thead>
					<tr>
						<th colSpan={2}>File</th>
						<UploadedCell>Uploaded</UploadedCell>
					</tr>
				</thead>
				
				<tbody>
					{documents?.map((document) => (
						<DocumentsRow key={document.id} document={document} pageID={pageID}></DocumentsRow>
					))}
					
					{documents?.length === 0 && <EmptyStateRow>No documents yet…</EmptyStateRow>}
					
					{!documents && <LoadingRow />}
				</tbody>
			</Table>
		</Container>
	);
};

export default Documents;
